module.exports = __webpack_public_path__ + "static/media/vlerat-02.dc32f25a.svg";